import React, { ReactElement } from "react";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import ServerAgent from "../ServerAgent";
import ServerStatistics from "../ServerStatistics";

const ServerMonitoring = (): ReactElement => {
 return (
  <Paper elevation={1} sx={{ borderRadius: "5px" }}>
   <Stack p={2} spacing={1}>
    <ServerAgent />
    <Divider />
    <ServerStatistics />
   </Stack>
  </Paper>
 );
};

export default ServerMonitoring;
